import { ModelLoadSource } from "../../utils/general.utils";

export const redactAssetUrl = (value: string) => {
  if (/^data:/i.test(value)) return "[data-url]";
  if (/^blob:/i.test(value)) return "[blob-url]";

  try {
    const parsed = new URL(value);
    if (!["http:", "https:"].includes(parsed.protocol)) {
      return `${parsed.protocol}[redacted]`;
    }
    return `${parsed.protocol}//${parsed.host}${parsed.pathname}`;
  } catch {
    return value.split(/[?#]/, 1)[0].slice(0, 512);
  }
};

const redactUrlsInText = (value: string) =>
  value.replace(/https?:\/\/[^\s"'<>]+/gi, (url) => redactAssetUrl(url));

export const sanitizeAssetError = (error: unknown) => {
  if (error instanceof Error) {
    return {
      name: error.name,
      message: redactUrlsInText(error.message).slice(0, 1024),
    };
  }
  return { message: redactUrlsInText(String(error)).slice(0, 1024) };
};

export const describeModelSource = (source: ModelLoadSource) => {
  if (typeof source === "string") return { kind: "url", value: redactAssetUrl(source) };
  if (typeof File !== "undefined" && source instanceof File) {
    return { kind: "file", name: source.name, size: source.size, type: source.type };
  }
  if (source && typeof source === "object") {
    const record = source as unknown as Record<string, unknown>;
    return {
      kind: String(record.type || "package"),
      url: typeof record.url === "string" ? redactAssetUrl(record.url) : undefined,
    };
  }
  return { kind: typeof source };
};
